import { PaymentTypeEnum } from 'graphQL/dinein/generate/operations'
import { useState } from 'react'
import { AdjustmentType } from 'helpers/promotion'
import { validateAdjusments } from 'helpers/promotion'
interface Props {
  trueWalletPhone: string
}

interface Order {
  id: number
  totalDueSatangs: number
  paymentType: PaymentTypeEnum
  adjustments: AdjustmentType[]
}

export enum InvalidOrder {
  None = 'None',
  ShouldShowTrueWalletPage = 'ShouldShowTrueWalletPage',
  TrueWalletPhoneNumberIsEmpty = 'TrueWalletPhoneNumberIsEmpty',
  InvalidAdjustment = 'InvalidAdjustment',
}

const useCheckout = ({ trueWalletPhone }: Props) => {
  const [isCheckoutProcessing, setIsCheckoutProcessing] = useState(false)
  const [isShowTrueWallet, setIsShowTrueWallet] = useState(false)
  const [isCashVoucherErrorZerodue, setIsCashVoucherErrorZerodue] = useState(false)

  const validateCheckout = (order: Order) => {
    const isTrueWallet = order.paymentType === PaymentTypeEnum.OmiseTrueMoneyWallet
    const isZeroCart = order.totalDueSatangs === 0
    if (!isZeroCart && isTrueWallet) {
      if (!isShowTrueWallet) {
        return { isOK: false, invalid: InvalidOrder.ShouldShowTrueWalletPage }
      } else if (!trueWalletPhone) {
        return { isOK: false, invalid: InvalidOrder.TrueWalletPhoneNumberIsEmpty }
      }
    }
    const validate = validateAdjusments(order.adjustments)
    setIsCashVoucherErrorZerodue(!validate)
    if (!validate) {
      return { isOK: false, invalid: InvalidOrder.ShouldShowTrueWalletPage }
    }
    return { isOK: true, invalid: InvalidOrder.None }
  }

  return {
    isCheckoutProcessing,
    setIsCheckoutProcessing,
    validateCheckout,
    isCashVoucherErrorZerodue,
    setIsCashVoucherErrorZerodue,
    isShowTrueWallet,
    setIsShowTrueWallet,
  }
}

export default useCheckout
